export default __webpack_public_path__ + "75555ee197750a42d2e568f7ae5889d4.svg";